import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { VialAssistanceRequest } from '../models/vial-assistance-request.model';
import { VialAssistanceResponse } from '../models/vial-assistance-response.model';
import { VialAssistanceSubserviceRequest } from '../models/vial-assistance-subservice-request.model';
import { VialAssistanceSubSericeResponse } from '../models/vial-assistance-subservice-response.model';

@Injectable({
  providedIn: 'root',
})
export class VialAssistanceService {
  private readonly baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) {}
  postVialAssistance(request: VialAssistanceRequest): Observable<VialAssistanceResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/file/${cognitoId}/add`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `${token}`,
    });
    return this.http.post<VialAssistanceResponse>(url, request, { headers });
  }


  postVialssistanceSubservice(request: VialAssistanceSubserviceRequest, subservices:String): Observable<VialAssistanceSubSericeResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/subservices/${subservices}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `${token}`,
    });
    return this.http.post<VialAssistanceSubSericeResponse>(url, request, { headers });
  }

}
